export const NEWS_ROUTER_ROOT = '/news';
export const NEWS_ROUTER_NEW = NEWS_ROUTER_ROOT + '/new';
export const NEWS_ROUTER_EDIT = NEWS_ROUTER_ROOT + '/edit/:id';



// WEBPACK FOOTER //
// ./src/components/News/constants.js